import { SystemStyleObject, defineStyleConfig } from '@chakra-ui/react';

const baseStyle: SystemStyleObject = {
  '--popper-arrow-bg': 'colors.white',
  bg: 'white',
  color: 'black',
  fontSize: 'xs',
  borderRadius: 4,
  padding: 2,
  border: '0px solid',
  marginTop: 2,
  textAlign: 'center',
};

export const Tooltip = defineStyleConfig({ baseStyle });
